var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="vis--row" id="'+
((__t=( id ))==null?'':__t)+
'"> <span class="vis--row_title"> <a href="'+
((__t=( baseurl ))==null?'':__t)+
'/companies/'+
((__t=( href ))==null?'':__t)+
'"> '+
((__t=( name ))==null?'':__t)+
' </a> </span> <span class="vis--category_score"> <span class="vis--category_score_value"> <span>'+
((__t=( score ))==null?'':__t)+
'</span> </span> </span> <div class="vis--row_bars"> '+
((__t=( barContent ))==null?'':__t)+
' </div> </div>';
}
return __p;
};
